import { Locales } from './i18n';

export const APP_PREFIX = 'wpayMerchant';
export const PRODUCTION_BOT_USERNAME = 'walt';
export const SUPPORT_LINK = 'https://t.me/WaltPay_support';
export const TERMS_OF_USE_PATH = '/static/documents/terms_of_use.pdf?v=3';
export const DOCUMENTATION_LINK = 'https://docs.walt.io/pay/';
export const TELEGRAM_STARS_DOCUMENTATION_LINK =
  'https://core.telegram.org/bots/api';
export const DEMO_BOT_LINK = 'https://t.me/PineAppleDemoWPStoreBot';
export const FAQ_LINKS: Record<Locales, string> = {
  en: 'https://help.walt.io/category/187-walt-pay',
  ru: 'https://help.ru.walt.io/category/193-walt-pay',
};

// process.env.BOT_USERNAME is an argument that should be passed during local development
// wallet is a string that will be replaced after build on demo stands and production.
export const BOT_USERNAME =
  process.env.IS_DEV && process.env.BOT_USERNAME
    ? process.env.BOT_USERNAME
    : 'wallet' || 'walt';

export const IS_PROD_ENV = BOT_USERNAME === PRODUCTION_BOT_USERNAME;

export const ALECTRYON_API_HOST = IS_PROD_ENV
  ? 'https://pay.walt.io'
  : window.location.origin;

if (process.env.IS_DEV && !process.env.BOT_USERNAME) {
  console.error(
    'In dev mode you have to pass BOT_USERNAME argument in `yarn start` command. Example: `BOT_USERNAME=demo3_2bot yarn start`',
  );
}

export function withAppPrefix<T extends string>(
  value: T,
): `${typeof APP_PREFIX}-${T}` {
  return `${APP_PREFIX}-${value}`;
}
